module.exports = __webpack_public_path__ + "static/img/14.e258343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/14.png
// module id = Fiq2
// module chunks = 0